// Stale-bundle detection for the auth-failure boundary (v1 copy of
// v2-ui/utils/utils.build — v1 never imports v2 libraries).
//
// A tab keeps the bundle it booted with until it reloads, so a fix only
// reaches users who happen to reload: a day after 3.0.21 shipped the redirect
// bridge, 104 users were still timing out on the 3.0.20 bundle
// (V1-CONSOLE-7PM). A failing session is the moment a stale bundle hurts
// most, and the one moment a reload costs nothing. Vite hashes the entry
// chunk per build, so "does index.html still point at the entry script this
// document loaded?" answers "is a newer build deployed?" without version
// plumbing. The dev server's unhashed entry is skipped.
let lastCheckAt = 0

const CHECK_THROTTLE_MS = 60 * 1000

/**
 * Resolves true when a newer build is live and the page is reloading — the
 * caller must then do nothing else. False when current, throttled, or
 * undeterminable; never throws.
 */
export async function reloadIfNewBuildAvailable(): Promise<boolean> {
  const entry = document.querySelector<HTMLScriptElement>(
    'script[type="module"][src]'
  )?.src
  if(!entry) return false
  const entryPath = new URL(entry, window.location.href).pathname
  if(!entryPath.includes("/assets/")) return false
  if(Date.now() - lastCheckAt < CHECK_THROTTLE_MS) return false
  lastCheckAt = Date.now()
  try {
    const res = await fetch("/", {
      cache: "no-store",
      headers: { accept: "text/html" }
    })
    if(!res.ok) return false
    const html = await res.text()
    if(html.includes(entryPath)) return false
    window.location.reload()
    return true
  } catch {
    return false
  }
}
